/**
 * **Kleine Beträge lesbar machen** (03.08.2026).
 *
 * Nils: *„die Kosten sind auf 0 – werden die nicht richtig ermittelt?"* Doch, sie wurden
 * richtig ermittelt: **0,082 Cent**. Angezeigt wurden sie als `(cent / 100).toFixed(2)` €,
 * und das ergibt `0.00 €`.
 *
 * Der Fehler war die **Einheit**, nicht die Zahl. Euro mit zwei Nachkommastellen ist die
 * richtige Darstellung für eine Rechnung und die falsche für einen Modellaufruf, der ein
 * Tausendstel Cent kostet – dort sagt sie nur „nichts", und „nichts" liest sich wie „kaputt".
 *
 * Deshalb richtet sich die Einheit nach dem Betrag:
 *
 * | Betrag | Anzeige |
 * |---|---|
 * | 0 | `–` |
 * | unter 1 Cent | `0,082 Cent` |
 * | unter 1 € | `8,2 Cent` |
 * | ab 1 € | `1,23 €` |
 */
export function betrag(cent: number): string {
  if (!Number.isFinite(cent) || cent <= 0) return '–'
  if (cent < 1) return `${cent.toLocaleString('de-DE', { maximumFractionDigits: 3 })} Cent`
  if (cent < 100) return `${cent.toLocaleString('de-DE', { maximumFractionDigits: 1 })} Cent`
  return `${(cent / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
}

/**
 * Ein Budget – immer in Euro, auch wenn es klein ist.
 *
 * Anders als beim Verbrauch: ein Budget **tippt jemand ein**, und zwar in Euro. Es in Cent
 * zurückzuspiegeln, weil es gerade klein ist, wäre eine Antwort auf eine Frage, die niemand
 * gestellt hat.
 */
export function budgetText(cent: number): string {
  return `${(cent / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
}
